export enum UtmParam {
  Source = "utm_source",
  Medium = "utm_medium",
  Campaign = "utm_campaign",
  Content = "utm_content",
}
